// extracted by mini-css-extract-plugin
export default {"noGatewayCompMsg":"paymentGateway__noGatewayCompMsg__Sd354"};